<template>
  <Modal wide>
    <template v-slot:header>
      <h2>Du har for mange ruter</h2>
      <p class="text-c">Dit nuværende abonnement <b>{{plan.name}}</b> tillader kun <b>{{limit}}</b> ruter.<br>Slet venligst <b>{{ routes.length - limit }}</b> rute(r) for at fortsætte.</p>
      <div class="upgrade">
        <p>Du kan også få plads til <b>10</b> ruter for kun <b>49 DKK</b>/måned</p> <AppButton color="primary" @click="$router.push('/account')">Mere info</AppButton>
      </div>
    </template>

    <RouteThumbnail v-for="route in routes" :route="route" :key="route.id" mode="delete" />
  </Modal> 
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { store } from '@/store'
import RouteThumbnail from '@/components/routes/RouteThumbnail.vue'

export default defineComponent({
  name: 'RouteLimitExceeded',
  components: { RouteThumbnail },
  setup() {
    const user = store.user.get(state => state)
    const plan = store.user.get(state => state.subscription.plan)
    const routes = computed(() => store.user.getUserRoutes())
    const limit = computed(() => plan.value.permissions.LIMIT_ROUTES)

    return { user, routes, limit, plan }
  }
})
</script>

<style lang="scss" scoped>
.route {
  margin-bottom: .5rem;

  &-preview {
    margin-left: 1rem;
  }
}
.upgrade {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #0066ff;
  color: white;
  font-weight: bold;
  padding: .25rem 2rem;
  border-radius: 0;
}
</style>